import {useCallback, useMemo, useState, useEffect} from 'react';
//import { AgGridReact } from 'ag-grid-react'; // React Data Grid Component
import { AgGridReact } from "@ag-grid-community/react";
import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the Data Grid
import "ag-grid-community/styles/ag-theme-quartz.css";
import "ag-grid-community/styles/ag-theme-balham.css"
import '../../components/TablaMaestra.css'
import { ModuleRegistry } from '@ag-grid-community/core';
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import { ColumnsToolPanelModule } from '@ag-grid-enterprise/column-tool-panel';
import {ExcelExportModule, MenuModule, RowGroupingModule, SetFilterModule, FiltersToolPanelModule, MultiFilterModule} from "ag-grid-enterprise";
import { fetchColumnDefinitions, fetchFilteredData } from '../../services/tablaMaestraService'
import MaestraOpcionesToolPanel from '../../components/aggrid/MaestraOpcionesToolPanel';
import DetalleMaestraEditar from '../../components/claim/DetalleQuickView';
import { Modal, ModalBody, ModalHeader, ModalFooter, Button } from '@heroui/react';
import { calcularDiasQueFaltan } from '../../utils/general/exporterUtil';
import { useAuth } from '../../components/auth/AuthProvider';
import { apiClient } from '../../services/apiClient';

ModuleRegistry.registerModules([
    ClientSideRowModelModule,
    ColumnsToolPanelModule,
    FiltersToolPanelModule,
    MenuModule,
    RowGroupingModule,
    SetFilterModule,
    MultiFilterModule,
    ExcelExportModule
]);

/** dd-mm-aaaa (fecha local) para celdas y listas del Set Filter */
function formatDateDdMmYyyy(value) {
    if (value == null || !(value instanceof Date) || isNaN(value.getTime())) {
        return '';
    }
    const d = String(value.getDate()).padStart(2, '0');
    const m = String(value.getMonth() + 1).padStart(2, '0');
    const y = value.getFullYear();
    return `${d}-${m}-${y}`;
}

/** Clave estable por día (yyyy-mm-dd) para el Set Filter */
function dateToIsoDateKey(value) {
    if (value == null || !(value instanceof Date) || isNaN(value.getTime())) {
        return '';
    }
    const y = value.getFullYear();
    const m = String(value.getMonth() + 1).padStart(2, '0');
    const d = String(value.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
}

/** Muestra dd-mm-aaaa en el Set Filter (valor Date o clave yyyy-mm-dd) */
function setFilterDateValueFormatter(params) {
    const v = params.value;
    if (v == null) return '';
    if (v instanceof Date) return formatDateDdMmYyyy(v);
    if (typeof v === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(v)) {
        const [y, mo, d] = v.split('-').map(Number);
        return formatDateDdMmYyyy(new Date(y, mo - 1, d));
    }
    return String(v);
}

function TablaMaestra({ darkMode }) {
    const { userProfile, loadingProfile } = useAuth();
    const isAdmin = userProfile?.permissions?.includes("admin");

    // Row Data: The data to be displayed.
    const [rowData, setRowData] = useState();

    // Column Definitions: Defines the columns to be displayed.
    const [colDefs, setColDefs] = useState([]);

    const [showEditarMaestra, setShowEditarMaestra] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [gridApi, setGridApi] = useState(null);

    const defaultColDef = useMemo(() => {
        return {
            filter: 'agMultiColumnFilter',
            filterParams: {
                filters: [
                    {
                        filter: 'agTextColumnFilter',
                        filterParams: {
                            suppressKeyboardEvents: false,
                            allowPaste: true
                        }
                    },
                    {
                        filter: 'agSetColumnFilter'
                    }
                ]
            },
            floatingFilter: true,
            enableCellChangeFlash: true
        };
    }, []);
    const rowSelection = {
        mode: "multiRow",
        enableClickSelection: true,
        checkboxes: false,
        headerCheckbox: false,
    }

    const getRowId = useCallback((params) => params.data.mr_id, []);

    const onCellEditRequest = useCallback(async (event) => {
        const oldData = event.data;
        const field = event.colDef.field; //Column
        const newValue = event.newValue; //Value
        const newData = { ...oldData };
        const dataToUpdate = { 'id': newData.mr_id || newData.id, 'column': field, 'newValue': newValue, 'oldValue': event.oldValue }
        newData[field] = event.newValue;
        console.log("onCellEditRequest, updating " + field + " to " + newValue);
        console.log("Data to update: ", dataToUpdate);
        console.log("event: ", event);

        //undefined deberia hacer un return

        try {
            // SEND POST REQUEST
            const response = await apiClient.post('/maestra/updateone', dataToUpdate);

            // HANDLE RESPONSE
            const updatedData = response.data; // Si el servidor devuelve datos
            console.log("Actualización exitosa", updatedData);

            // APPLY AGGRID TX
            const tx = {
                update: [newData],
            };
            event.api.applyTransaction(tx);

        } catch (error) {
            console.error("Error al enviar la solicitud: ", error);
            const errorMsg = error.response?.data || error.message;
            alert("Error al actualizar el dato: " + JSON.stringify(errorMsg));
        }

    }, []);

    const getMoneySymbolByColumn = (columnName) => {
        let symbol;
        switch(columnName){
            case 'mr_monto_indemnizado_usd':
            case 'mr_reclamo_usd':
            case 'mr_expectativas_usd':
            case 'mr_recuperado_usd':
                symbol = '$';
                break;

            case 'mr_reclamo_euros':
            case 'mr_recuperado_euros':
                symbol = '€';
                break;

            default:
                symbol = '';
                break;
        }
        return symbol
    }

    const setColumTypeFromPostgresTableDefinition = (column, currentClients = [], isAdmin = false) => {
        const editableColumns = [
            'mr_comentario',
            'mr_reclamo_a_terceros',
            'mr_monto_indemnizado_usd',
            'mr_deducible',
            'mr_claudio',
            'mr_reclamo_usd',
            'mr_reclamo_euros',
            'mr_expectativas_usd',
            'mr_recuperado_usd',
            'mr_recuperado_euros',
            'mr_status'
        ];

        if (isAdmin) {
            editableColumns.push('mr_cliente');
        }

        // Procesar el headerName
        let headerName = column.column_name.includes('_')
            ? column.column_name.split('_') // Divide por '_'
                .slice(1) // Toma todo después del primer '_'
                .map((word, index) =>
                    index === 0
                        ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() // Primera palabra capitalizada
                        : word.toLowerCase() // Siguientes palabras en lowercase
                )
                .join(' ') // Une sin separadores
            : column.column_name;
        
        let headerTooltip = undefined;

        if (column.column_name === 'mr_embarcador') {
            headerName = 'Exporter';
            headerTooltip = 'Embarcador';
        } else if (column.column_name === 'mr_cliente') {
            headerName = 'Client';
        } else if (column.column_name === 'mr_dias_que_faltan') {
            headerName = 'Remaining';
            headerTooltip = 'Días que faltan';
        } else if (column.column_name === 'mr_a_cargo') {
            headerName = 'In Charge';
            headerTooltip = 'A cargo';
        }

        
        //console.log("type: " + column.column_name);
        //console.log("column data: ", column)

        let colData = {
            //columnGroupShow: 'open',
            headerName: headerName,
            ...(headerTooltip && { headerTooltip })
        };
        
        switch(column.data_type){
            case "uuid":
                if(column.column_name === "mr_id" || column.column_name === "mj_maestra_recuperos_id"){
                    colData = {
                        ...colData,
                        field: column.column_name, editable: editableColumns.includes(column.column_name),
                        hide: true,
                        suppressColumnsToolPanel: true,
                        cellClassRules: {
                            'non-editable-cell': (params) => !params.colDef.editable, // Aplica la clase si no es editable
                        }
                    };
                }else{
                    colData = {
                        field: column.column_name, editable: editableColumns.includes(column.column_name),
                        cellClassRules: {
                            'non-editable-cell': (params) => !params.colDef.editable, // Aplica la clase si no es editable
                        },
                    };
                }

                break;
            case "timestamp without time zone":
            case "timestamp with time zone": //ambos timestamp
            case "date":
                colData =
                    {
                        ...colData,
                        field: column.column_name, cellEditor: 'agDateCellEditor', editable: editableColumns.includes(column.column_name),
                        filter: 'agMultiColumnFilter',
                        filterParams: {
                            filters: [
                                { filter: 'agDateColumnFilter' },
                                {
                                    filter: 'agSetColumnFilter',
                                    filterParams: {
                                        keyCreator: (p) => dateToIsoDateKey(p.value),
                                        valueFormatter: setFilterDateValueFormatter,
                                        comparator: (a, b) => {
                                            if (a == null && b == null) return 0;
                                            if (a == null) return -1;
                                            if (b == null) return 1;
                                            return String(a).localeCompare(String(b));
                                        }
                                    }
                                }
                            ]
                        },
                        valueGetter: (params) => {
                            //Convertir a fecha de JS
                            return params.data && params.data[column.column_name] ? new Date(params.data[column.column_name]) : null;
                        },
                        valueFormatter: (params) => {
                            return formatDateDdMmYyyy(params.value);
                        },
                        cellClassRules: {
                            'non-editable-cell': (params) => !params.colDef.editable, // Aplica la clase si no es editable
                        },
                        enableRowGroup: true,
                        enablePivot: true,
                    };

                break;
            case "character varying": //character_maximum_length: 255
                if(column.column_name === "status"){
                    colData = {
                        ...colData,
                        field: column.column_name,
                        cellEditor: 'agSelectCellEditor',
                        editable: editableColumns.includes(column.column_name),
                        cellEditorParams: {
                            values: ['Ready to Claim', 'Juicio Chile', 'Juicio Perú', 'Finiquito Firmado', 'Reclamado', 'Cerrado',],
                            //valueListMaxHeight: 120,
                            //valueListMaxWidth: 120,
                            maxLength: column.character_maximum_length
                        },
                        cellClassRules: {
                            'non-editable-cell': (params) => !params.colDef.editable, // Aplica la clase si no es editable
                        },
                        enableRowGroup: true,
                        enablePivot: true,
                    }
                } else if(column.column_name === "mr_rsk_ref") {
                    // Caso especial para fijar la columna RSK Ref
                    colData = {
                        ...colData,
                        field: column.column_name,
                        cellEditor: 'agTextCellEditor',
                        editable: editableColumns.includes(column.column_name),
                        cellEditorParams: {
                            maxLength: column.character_maximum_length
                        },
                        pinned: 'left', // Fijar la columna a la izquierda
                        sort: column.column_name === 'rsk_ref_number' ? 'desc' : false,
                        cellClassRules: {
                            'non-editable-cell': (params) => !params.colDef.editable, // Aplica la clase si no es editable
                        },
                        enableRowGroup: true,
                        enablePivot: true,
                    }
                } else if (column.column_name === "mr_cliente") {
                    colData = {
                        ...colData,
                        field: column.column_name,
                        cellEditor: 'agSelectCellEditor',
                        editable: editableColumns.includes(column.column_name),
                        cellEditorParams: {
                            values: currentClients,
                        },
                        valueFormatter: (params) => {
                            if (params.value === 'DIRECTO' && params.data && params.data.mr_embarcador) {
                                return params.data.mr_embarcador;
                            }
                            return params.value;
                        },
                        cellClassRules: {
                            'non-editable-cell': (params) => !params.colDef.editable,
                        },
                        enableRowGroup: true,
                        enablePivot: true,
                    }
                } else {
                    colData = {
                        ...colData,
                        field: column.column_name,
                        cellEditor: 'agTextCellEditor',
                        editable: editableColumns.includes(column.column_name),
                        cellEditorParams: {
                            maxLength: column.character_maximum_length
                        },
                        sort: column.column_name === 'rsk_ref_number' ? 'desc' : false,
                        cellClassRules: {
                            'non-editable-cell': (params) => !params.colDef.editable, // Aplica la clase si no es editable
                        },
                        enableRowGroup: true,
                        enablePivot: true,
                    }
                }
                break;
            case "text": //no character limit
                if(column.column_name === "mr_dias_que_faltan") {
                    // Caso especial para la columna de días que faltan
                    colData = {
                        ...colData,
                        field: column.column_name,
                        // valueGetter para ordenamiento numérico
                        valueGetter: (params) => {
                            const timeExtension = params.data && params.data['mr_time_extension'];
                            const fechaArribo = params.data && params.data['mr_fecha_arribo'];
                            const diasQueFaltan = calcularDiasQueFaltan(timeExtension, fechaArribo);
                            
                            // Usar el valor calculado, si no existe será null
                            const value = diasQueFaltan || null;
                            
                            if (!value || value === "N/A") return 999999; // N/A va al final
                            if (value === "Vencido") return 999998; // Vencido va antes que N/A
                            const num = parseInt(value);
                            return isNaN(num) ? 999999 : num; // Números normales para ordenamiento
                        },
                        // valueFormatter para mostrar el texto calculado
                        valueFormatter: (params) => {
                            const timeExtension = params.data && params.data['mr_time_extension'];
                            const fechaArribo = params.data && params.data['mr_fecha_arribo'];
                            const diasQueFaltan = calcularDiasQueFaltan(timeExtension, fechaArribo);
                            
                            // Usar el valor calculado, si no existe será null y mostrará N/A
                            return diasQueFaltan || 'N/A';
                        },
                        cellClassRules: {
                            'dias-critico': (params) => {
                                const timeExtension = params.data && params.data['mr_time_extension'];
                                const fechaArribo = params.data && params.data['mr_fecha_arribo'];
                                const diasCalculados = calcularDiasQueFaltan(timeExtension, fechaArribo);
                                const dias = diasCalculados || null;
                                
                                if (!dias || dias === "N/A" || dias === "Vencido") return false;
                                const diasNum = parseInt(dias);
                                return !isNaN(diasNum) && diasNum <= 30;
                            },
                            'dias-advertencia': (params) => {
                                const timeExtension = params.data && params.data['mr_time_extension'];
                                const fechaArribo = params.data && params.data['mr_fecha_arribo'];
                                const diasCalculados = calcularDiasQueFaltan(timeExtension, fechaArribo);
                                const dias = diasCalculados || null;
                                
                                if (!dias || dias === "N/A" || dias === "Vencido") return false;
                                const diasNum = parseInt(dias);
                                return !isNaN(diasNum) && diasNum > 30 && diasNum <= 60;
                            },
                            'dias-normal': (params) => {
                                const timeExtension = params.data && params.data['mr_time_extension'];
                                const fechaArribo = params.data && params.data['mr_fecha_arribo'];
                                const diasCalculados = calcularDiasQueFaltan(timeExtension, fechaArribo);
                                const dias = diasCalculados || null;
                                
                                if (!dias || dias === "N/A" || dias === "Vencido") return false;
                                const diasNum = parseInt(dias);
                                return !isNaN(diasNum) && diasNum > 60;
                            },
                            'dias-vencido': (params) => {
                                const timeExtension = params.data && params.data['mr_time_extension'];
                                const fechaArribo = params.data && params.data['mr_fecha_arribo'];
                                const diasCalculados = calcularDiasQueFaltan(timeExtension, fechaArribo);
                                const dias = diasCalculados || null;
                                
                                return !dias || dias === "N/A" || dias === "Vencido";
                            }
                        },
                        sortable: true,
                        // sort: 'desc', // Ordenar por defecto de mayor a menor
                        filter: true,
                        enableRowGroup: true,
                        enablePivot: true,
                        width: 120
                    };
                } else {
                    colData = {
                        ...colData,
                        field: column.column_name, cellEditor: 'agLargeTextCellEditor', editable: editableColumns.includes(column.column_name),
                        cellEditorPopup: true,
                        cellClassRules: {
                            'non-editable-cell': (params) => !params.colDef.editable, // Aplica la clase si no es editable
                        },
                        enableRowGroup: true,
                        enablePivot: true,
                    };
                }
                break;
            case "smallint": //numeric_precision: 16 (smallint = 16) / numeric_scale (normally numeric scale for smallint is 0)
            case "integer": //numeric_precision: 32 (int32) / numeric_scale both integers (normally numeric scale for integer is 0)
                if(column.column_name === "mj_id"){
                    colData = {
                        ...colData,
                        field: column.column_name, editable: editableColumns.includes(column.column_name),
                        hide: true,
                        suppressColumnsToolPanel: true,
                        cellClassRules: {
                            'non-editable-cell': (params) => !params.colDef.editable, // Aplica la clase si no es editable
                        }
                    };
                }else {
                    colData = {
                        ...colData,
                        field: column.column_name,
                        cellEditor: 'agNumberCellEditor',
                        editable: editableColumns.includes(column.column_name),
                        cellEditorParams: {
                            min: -Math.pow(10, column.numeric_precision) + 1,
                            max: Math.pow(10, column.numeric_precision) - 1
                        },
                        valueGetter: params => {
                            const value = params.data && params.data[column.column_name];
                            // Si el valor es nulo, undefined, o una cadena vacía, devolver null
                            if (value === null || value === undefined || value === '') {
                                return null;
                            }
                            const num = Number(value);
                            return isNaN(num) ? null : num;
                        },
                        valueFormatter: (params) => {
                            // Si el valor es nulo o undefined, mostrar vacío
                            if (params.value === null || params.value === undefined) {
                                return '';
                            }
                            // Si el valor es 0, mostrarlo normalmente
                            return params.value.toString();
                        },
                        cellClassRules: {
                            'non-editable-cell': (params) => !params.colDef.editable, // Aplica la clase si no es editable
                        },
                        enableValue: true,
                    }
                }

                break;
            case "numeric": //numeric_precision / numeric_scale both integers
                // Cálculo del rango
                const max = Math.pow(10, column.numeric_precision - column.numeric_scale) - Math.pow(10, -column.numeric_scale); // Máximo positivo
                const min = -max; // Mínimo negativo
                colData = {
                    ...colData,
                    field: column.column_name, cellEditor: 'agNumberCellEditor', editable: editableColumns.includes(column.column_name),
                    cellEditorParams: {
                        min: min,
                        max: max,
                        precision: column.numeric_scale
                        //step: Math.pow(10, -column.numeric_scale), // Incremento basado en la escala
                    },
                    valueFormatter: (params) => {
                        // Si el valor es nulo o undefined, mostrar vacío
                        if (params.value === null || params.value === undefined) {
                            return '';
                        }
                        // Si el valor es 0, mostrarlo normalmente
                        return `${getMoneySymbolByColumn(column.column_name)} ${Number(params.value).toFixed(column.numeric_scale)}`;
                    },
                    valueGetter: params => {
                        const value = params.data && params.data[column.column_name];
                        // Si el valor es nulo, undefined, o una cadena vacía, devolver null
                        if (value === null || value === undefined || value === '') {
                            return null;
                        }
                        const num = Number(value);
                        // Si el número es 0, verificar si realmente es 0 o si era nulo
                        if (num === 0 && (value === null || value === undefined || value === '')) {
                            return null;
                        }
                        return isNaN(num) ? null : num;
                    },
                    cellClassRules: {
                        'non-editable-cell': (params) => !params.colDef.editable, // Aplica la clase si no es editable
                    },
                    //enableRowGroup: true,
                    //enablePivot: true,
                    enableValue: true,
                };

                break;
            default:
                colData = {
                    ...colData,
                    field: column.column_name, editable: editableColumns.includes(column.column_name),
                    cellClassRules: {
                        'non-editable-cell': (params) => !params.colDef.editable, // Aplica la clase si no es editable
                    },
                };
                break;
        }

        return colData;
    }

    const onGridReady = useCallback((params) => {
        setGridApi(params.api);
    }, []);

    useEffect(() => {
        if (!gridApi || loadingProfile) return;

        const loadData = async () => {
            try {
                // Fetch clients if admin
                let currentClients = [];
                if (isAdmin) {
                    try {
                        const response = await apiClient.get('/maestra/clients');
                        currentClients = ['', ...response.data.map(c => c.abbreviation)];
                    } catch (error) {
                        console.error("Error fetching clients:", error);
                    }
                }

                // Obtener definición de columnas
                const columnDefinitions = await fetchColumnDefinitions();
                const colDefs = columnDefinitions.map(col => setColumTypeFromPostgresTableDefinition(col, currentClients, isAdmin));

                const tabla_maestra = colDefs.filter((row) =>
                    row.field.split('_')[0] === "mr"
                );
                const tabla_judicial = colDefs.filter((row) =>
                    row.field.split('_')[0] === "mj"
                );

                // Reordenar columnas de tabla_maestra para que fechas de creación y actualización aparezcan después de fecha_oferta
                const reorderMaestraColumns = (columns) => {
                    const fechaOfertaIndex = columns.findIndex(col => col.field === 'mr_fecha_oferta');
                    if (fechaOfertaIndex === -1) return columns; // Si no existe fecha_oferta, no hacer nada
                    
                    const fechaCreacionIndex = columns.findIndex(col => col.field === 'mr_fecha_creacion');
                    const fechaActualizacionIndex = columns.findIndex(col => col.field === 'mr_fecha_actualizacion');
                    
                    if (fechaCreacionIndex === -1 && fechaActualizacionIndex === -1) return columns; // Si no existen las fechas, no hacer nada
                    
                    const reorderedColumns = [...columns];
                    const fechaOferta = reorderedColumns[fechaOfertaIndex];
                    
                    // Remover las fechas de creación y actualización de sus posiciones actuales
                    // Remover primero el de mayor índice para evitar problemas con splice
                    const fechaCreacion = fechaCreacionIndex !== -1 ? reorderedColumns[fechaCreacionIndex] : null;
                    const fechaActualizacion = fechaActualizacionIndex !== -1 ? reorderedColumns[fechaActualizacionIndex] : null;
                    
                    // Remover elementos de mayor índice a menor
                    if (fechaActualizacionIndex !== -1) {
                        reorderedColumns.splice(fechaActualizacionIndex, 1);
                    }
                    if (fechaCreacionIndex !== -1) {
                        reorderedColumns.splice(fechaCreacionIndex, 1);
                    }
                    
                    // Encontrar la nueva posición después de fecha_oferta
                    const newFechaOfertaIndex = reorderedColumns.findIndex(col => col.field === 'mr_fecha_oferta');
                    
                    // Insertar las fechas después de fecha_oferta
                    if (fechaCreacion) {
                        fechaCreacion.hide = true; // Ocultar fecha de creación
                        reorderedColumns.splice(newFechaOfertaIndex + 1, 0, fechaCreacion);
                    }
                    if (fechaActualizacion) {
                        reorderedColumns.splice(newFechaOfertaIndex + 2, 0, fechaActualizacion);
                    }
                    
                    return reorderedColumns;
                };

                const tabla_maestra_reordered = reorderMaestraColumns(tabla_maestra);

                const columnDefs = [
                    {
                        headerName: 'Tabla Maestra',
                        children: tabla_maestra_reordered
                    },
                    {
                        headerName: 'Tabla Judicial',
                        children: tabla_judicial
                    }
                ]
                setColDefs(columnDefs)

                // Obtener datos filtrados
                const rowData = await fetchFilteredData();
                
                setRowData(rowData);
            } catch (error) {
                console.error('Error al cargar los datos:', error);
            }
        };

        loadData();
    }, [gridApi, loadingProfile, isAdmin]);

    const handleEditarMaestra = (row) => {
        setSelectedRow(row);
        setShowEditarMaestra(true);
    };

    const sideBar = useMemo(() => ({
        toolPanels: [
            {
                id: "columns",
                labelDefault: "Columns",
                iconKey: "columns",
                toolPanel: "agColumnsToolPanel"
            },
            {
                id: "options",
                labelDefault: "Options",
                iconKey: "options",
                toolPanel: MaestraOpcionesToolPanel,
                toolPanelParams: {
                    api: gridApi,
                    onEditarMaestra: handleEditarMaestra
                }
            }
        ],
        defaultToolPanel: "options"
    }), [gridApi]);

    return (
        <div
            className={`${darkMode ? "ag-theme-balham-dark" : "ag-theme-balham"} h-[calc(100vh-64px)] w-full`}
        >
            <AgGridReact
                rowData={rowData}
                columnDefs={colDefs}
                defaultColDef={defaultColDef}
                rowSelection={rowSelection}
                getRowId={getRowId}
                readOnlyEdit={true}
                onCellEditRequest={onCellEditRequest}
                sideBar={sideBar}
                onGridReady={onGridReady}
                tooltipShowDelay={500}
            />
            <Modal isOpen={showEditarMaestra} onClose={() => setShowEditarMaestra(false)}>
                <ModalHeader>Editar Tabla Maestra</ModalHeader>
                <ModalBody>
                    <DetalleMaestraEditar maestraData={selectedRow || {}} />
                </ModalBody>
                <ModalFooter>
                    <Button color="danger" variant="light" onPress={() => setShowEditarMaestra(false)}>
                        Cerrar
                    </Button>
                </ModalFooter>
            </Modal>
        </div>
    );
}

export default TablaMaestra;